import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { HAS_CREATE_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const routeReturnPurchaseReceiptCreate: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/purchaseReceipt/AddReturnPurchaseReceipt.vue')
  },
  meta: { doctypes: { [DOCTYPES.PURCHASE_RECEIPT]: HAS_CREATE_VIEW_ONE_PERMISSION_OF } },
  name: 'new-return-purchase-receipt',
  path: 'new-return-purchase-receipt',
}

const {
  create: routePurchaseReceiptCreate,
  detail: routePurchaseReceiptDetail,
  home: routePurchaseReceiptsHome,
  root: routePurchaseReceiptsRoot,
} = createDoctypeRoutes({
  createName: 'new-purchase-receipt',
  createPath: 'new-purchase-receipt',
  detailName: 'purchase-receipt-detail',
  doctype: DOCTYPES.PURCHASE_RECEIPT,
  extraRoutes: [routeReturnPurchaseReceiptCreate],
  homeName: 'purchase-receipts-home',
  ifOwner: false,
  path: 'purchase-receipts',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/purchaseReceipt/AddPurchaseReceipt.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/purchaseReceipt/ViewPurchaseReceipt.vue'),
    list: async () =>
      await import('@/components/viewsExternal/purchaseReceipt/PurchaseReceiptView.vue'),
  },
})

export {
  routePurchaseReceiptCreate,
  routePurchaseReceiptDetail,
  routePurchaseReceiptsHome,
  routePurchaseReceiptsRoot,
  routeReturnPurchaseReceiptCreate,
}
